import {
  Box,
  HStack,
  Icon,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
  SimpleGrid,
  Spinner,
  Text,
} from "@chakra-ui/react";
import { FaChevronDown } from "react-icons/fa";
import { useDimensionFilters } from "../Hooks/useDimensionFilters";

const getOptionLabel = (item, isRTL) => {
  const preferred = isRTL ? item?.nameAr || item?.name : item?.nameEn || item?.name;
  return typeof preferred === "string" && preferred ? preferred : String(item?.id ?? "");
};

const DimensionSelect = ({ filterKey, handleApplyFilters, isLoading, isRTL, items, label, selected }) => (
  <Box h="full">
    <Menu closeOnSelect={false}>
      <MenuButton
        w="full"
        variant="outline"
        size="sm"
        textAlign={isRTL ? "right" : "left"}
        h="40px"
        display="flex"
        alignItems="center"
      >
        <HStack spacing={2} w="full" justify={isRTL ? "flex-end" : "flex-start"}>
          {isRTL && <Icon as={FaChevronDown} />}
          {isLoading && <Spinner size="xs" />}
          <Text noOfLines={1} flex={1}>
            {label}
            {selected.length > 0 ? ` (${selected.length})` : ""}
          </Text>
          {!isRTL && <Icon as={FaChevronDown} />}
        </HStack>
      </MenuButton>
      <MenuList maxH="300px" overflowY="auto" minW="240px">
        <MenuOptionGroup
          type="checkbox"
          value={selected}
          onChange={(value) => handleApplyFilters({ [filterKey]: Array.isArray(value) ? value : [value] })}
        >
          {items.map((item) => (
            <MenuItemOption key={item.id} value={String(item.id)} textAlign={isRTL ? "right" : "left"}>
              {getOptionLabel(item, isRTL)}
            </MenuItemOption>
          ))}
        </MenuOptionGroup>
      </MenuList>
    </Menu>
  </Box>
);

const DimensionFilters = ({ filters, handleApplyFilters, isRTL, t }) => {
  const { options, isLoading } = useDimensionFilters();

  const dimensions = [
    { filterKey: "branches", items: options.branches, label: t("reports.branches", isRTL ? "الفروع" : "Branches") },
    { filterKey: "projects", items: options.projects, label: t("reports.projects", isRTL ? "المشاريع" : "Projects") },
    { filterKey: "costCenters", items: options.costCenters, label: t("reports.costCenters", isRTL ? "مراكز التكلفة" : "Cost Centers") },
  ].filter((dimension) => isLoading || dimension.items.length > 0);

  if (!isLoading && dimensions.length === 0) return null;

  return (
    <SimpleGrid columns={{ base: 1, sm: 3 }} spacing={3}>
      {dimensions.map((dimension) => (
        <DimensionSelect
          key={dimension.filterKey}
          filterKey={dimension.filterKey}
          handleApplyFilters={handleApplyFilters}
          isLoading={isLoading}
          isRTL={isRTL}
          items={dimension.items}
          label={dimension.label}
          selected={(filters?.[dimension.filterKey] || []).map(String)}
        />
      ))}
    </SimpleGrid>
  );
};

export default DimensionFilters;
